import Header from './scripts';
import './styles/header.scss';
import './styles/navigation.scss';

Header.init();
